<template>
	<div class="page-wrap login-page">
		<v-card width="600px">
			<v-card-title class="headline grey lighten-2 px-8"> Sign In </v-card-title>

			<v-divider></v-divider>

			<div class="container px-8">
				<div class="row">
					<div class="col-sm-12">
						<v-text-field label="Username" v-model="username" :error-messages="usernameErrors" @input="$v.username.$touch()" @blur="$v.username.$touch()"></v-text-field>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12">
						<v-text-field label="Password" v-model="password" type="password" :error-messages="passwordErrors" @input="$v.password.$touch()" @blur="$v.password.$touch()"></v-text-field>
					</div>
				</div>
			</div>

			<v-card-actions class="headline grey lighten-2 px-8">
                <v-btn color="primary" text link to="/register"> Sign Up </v-btn>
				<v-spacer></v-spacer>
				<v-btn @click="submit()" color="primary"> Sign In </v-btn>
			</v-card-actions>
		</v-card>

		<div class="forgot-password-link">
			<v-btn color="primary" text link to="/forgot-password"> Forgot your password? </v-btn>
		</div>
	</div>
</template>

<script>
	import { login } from '../api/common';

	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	import './style.scss';

	export default {
		name: 'Login',
		components: {},
		mixins: [validationMixin],
		validations: {
			password: { required },
			username: { required },
		},
		data: () => {
            return {
				remember: false,
				username: '',
				password: ''
            }
		},
		
		computed: {
			passwordErrors () {
				const errors = [];

				if (!this.$v.password.$dirty){
					return errors;
				}

				!this.$v.password.required && errors.push('Password is required.');

				return errors;
			},
			usernameErrors () {
				const errors = [];
				if (!this.$v.username.$dirty){
					return errors;
				}

				!this.$v.username.required && errors.push('Username is required');

				return errors;
			}
		},

		methods: {
			submit() {
				this.$v.$touch();
				
				if(!this.usernameErrors.length && !this.passwordErrors.length){
					return new Promise((resolve, reject) => {
						let bodyFormData = new FormData();

						bodyFormData.append('username', this.username);
                    	bodyFormData.append('password', this.password);

						login(bodyFormData).then(res => {
							
							this.$router.push('/');
						}).catch(error => {
							console.log(error);
							this.$store.dispatch('Common/setError', error.data, { root: true });

							reject(error);
						})
					});
				}
			},

			clear () {
				this.$v.$reset()
				this.password = '';
				this.email = '';
			}
		}
	}
</script>

<style>

</style>
